export default __webpack_public_path__ + "static/media/blackberry-radar1.70c11f5d.png";